import styled from 'styled-components'

export default function Campaign() {
  return null
}

//        <CampaignContainer>
//          <CampaignImage src="easter2025.webp" />          
//          <h1>🎉🎉 JANUAR KAMPANJE 🎉🎉</h1>
//          <CampaignText>Alle some bestiller et abonnement i januar får 1 gratis pose kaffe ved første levering!</CampaignText>
//          <iframe width={res[0]} height={res[1]} 
//            src="https://www.youtube.com/embed/M9SsBH49jZ8?si=Xo7XbcJc-DVjt9Jy" 
//            title="YouTube video player" 
//            frameBorder="0" 
//            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen>
//          </iframe>
//        </CampaignContainer>

const CampaignImage = styled.img`

`

const CampaignSection = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  background-color: var(--color-splash-yellow);
  padding: 20px;

  @media (max-width: 768px) {
    padding: 30px 10px;
  }
`

const CampaignContainer = styled.div`
  padding: 0px 20px; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: auto;

  & iframe {
    margin-top: 20px;
  }

  & h1 {
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 1.3em;
    }
  }
`

const CampaignText = styled.div`
  text-align: center;
`
